import OutletsOnMap from "./outlets-on-map";
export default OutletsOnMap;
